import React from 'react';
import { UserCheck, Users, Smartphone } from '@/utils/icons';

interface OverviewTabProps {
    selectedTeam: any;
    isDark: boolean;
    formatDate: (date: string) => string;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ selectedTeam, isDark, formatDate }) => (
    <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className={`cgm-metric-card text-center`}>
                <div className="flex items-center justify-center mb-4">
                    <UserCheck className="w-10 h-10 cgm-icon-data" />
                </div>
                <div className="text-3xl font-bold cgm-text-primary mb-2">{selectedTeam.coaches.length}</div>
                <div className="text-sm cgm-text-secondary font-medium">Coaches</div>
            </div>
            <div className={`cgm-metric-card text-center`}>
                <div className="flex items-center justify-center mb-4">
                    <Users className="w-10 h-10 cgm-icon-neutral" />
                </div>
                <div className="text-3xl font-bold cgm-text-primary mb-2">{selectedTeam.athletes.length}</div>
                <div className="text-sm cgm-text-secondary font-medium">Athletes</div>
            </div>
            <div className={`cgm-metric-card text-center`}>
                <div className="flex items-center justify-center mb-4">
                    <Smartphone className="w-10 h-10 cgm-icon-activity" />
                </div>
                <div className="text-3xl font-bold cgm-text-primary mb-2">{selectedTeam.athletes.filter((athlete: any) => athlete.whoop_connected).length}</div>
                <div className="text-sm cgm-text-secondary font-medium">Connected Devices</div>
            </div>
        </div>

        {selectedTeam.description && (
            <div className={`cgm-card rounded-2xl p-6`}>
                <h4 className="text-lg font-semibold cgm-text-primary mb-3">Team Description</h4>
                <p className="cgm-text-secondary leading-relaxed">{selectedTeam.description}</p>
            </div>
        )}

        <div className={`cgm-card rounded-2xl p-6`}>
            <h4 className="text-lg font-semibold cgm-text-primary mb-3">Team Details</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <span className="text-sm cgm-text-secondary font-medium">Sport:</span>
                    <span className="ml-2 cgm-text-primary">{selectedTeam.sport || 'N/A'}</span>
                </div>
                <div>
                    <span className="text-sm cgm-text-secondary font-medium">Gender:</span>
                    <span className="ml-2 cgm-text-primary">{selectedTeam.gender || 'N/A'}</span>
                </div>
                <div>
                    <span className="text-sm cgm-text-secondary font-medium">Created:</span>
                    <span className="ml-2 cgm-text-primary">{formatDate(selectedTeam.created_at)}</span>
                </div>
            </div>
        </div>
    </div>
);

export default OverviewTab; 
